import React, {useEffect, useRef} from "react";
import * as d3 from "d3";
import * as Math from "mathjs"
import Box from '@material-ui/core/Box';

const Output2 = (props) => {
  const ref = useRef()
  useEffect(() => {

    let dimensions = {
      width: 800,
      height: 400,
      margin: {
        top: 20,
        right: 10,
        bottom: 50,
        left: 50
      }
    }

    dimensions.boundedWidth = dimensions.width - dimensions.margin.left - dimensions.margin.right
    dimensions.boundedHeight = dimensions.height - dimensions.margin.top - dimensions.margin.bottom

    const svgElement = d3.select(ref.current).attr("width", dimensions.width).attr("height", dimensions.height)

    svgElement.selectAll('*').remove()

    const bounds = svgElement.append("g").style("transform", `translate(${dimensions.margin.left}px, ${dimensions.margin.top}px)`)

    // Data Retrieve and process data => x*beta
    let {
      age,
      sob,
      temperature,
      hct,
      hgb,
      lymphocyte,
      wbc,
      plt
    } = props.data

    // Process Data: Standardize & Age transformation
    let age1 = 0
    let age2 = 0
    let age3 = 0

    if (age < 20) {
      age1 = -7
      age2 = 7
      age3 = -7
    } else if (age < 30) {
      age1 = -5
      age2 = 1
      age3 = 5
    } else if (age < 40) {
      age1 = -3
      age2 = -3
      age3 = 7
    } else if (age < 50) {
      age1 = -1
      age2 = -5
      age3 = 3
    } else if (age < 60) {
      age1 = 1
      age2 = -5
      age3 = -3
    } else if (age < 70) {
      age1 = 3
      age2 = -3
      age3 = -7
    } else if (age < 80) {
      age1 = 5
      age2 = 1
      age3 = -5
    } else {
      age1 = 7
      age2 = 7
      age3 = 7
    }

    temperature = (temperature > 37.5)
      ? 1
      : 0
    hct = (hct - 39.2609) / 4.9382
    hgb = (hgb - 13.2827) / 1.7563
    lymphocyte = (lymphocyte - 29.1430) / 11.6875
    wbc = (wbc - 6126) / 2824
    plt = (plt - 237882.4) / 83295.69
    // Calculate Coef and etc from R
    // coef : age, sob, temp,hct, lympho, plt

    const coef0 = -2.77
    const [coef1, coef2, coef3, coef4, coef5, coef6, coef7, coef8] = [
      [
        0.249, 0.044, 0.002
      ],
      1.872,
      0.811,
      -0.106,
      0,
      -0.787,
      0,
      -0.378
    ]
    const [ageMin, sobMin, tempMin, hctMin, hgbMin, lympMin, wbcMin, pltMin] = [
      Math.min(coef1[0] * (-7), coef1[0] * (7)) + Math.min(coef1[1] * (-5), coef1[1] * (7)) + Math.min(coef1[2] * (-7), coef1[2] * (7)),
      Math.min(coef2 * 0, coef2 * 1),
      Math.min(coef3 * 0, coef3 * 1),
      Math.min(coef4 * (11.6 - 39.2609) / 4.9382, coef4 * (72.9 - 39.2609) / 4.9382),
      Math.min(coef5 * (5.2 - 13.2827) / 1.7563, coef5 * (20.3 - 13.2827) / 1.7563),
      Math.min(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.min(coef7 * (660 - 6126) / 2824, coef7 * (55000 - 6126) / 2824),
      Math.min(coef8 * (5300 - 237882.4) / 83295.69, coef8 * (734000 - 237882.4) / 83295.69)
    ]
    // Max는 coef가 곱해진 값이다!!
    const [ageMax, sobMax, tempMax, hctMax, hgbMax, lympMax, wbcMax, pltMax] = [
      Math.max(coef1[0] * (-7), coef1[0] * (7)) + Math.max(coef1[1] * (-5), coef1[1] * (7)) + Math.max(coef1[2] * (-7), coef1[2] * (7)),
      Math.max(coef2 * 0, coef2 * 1),
      Math.max(coef3 * 0, coef3 * 1),
      Math.max(coef4 * (11.6 - 39.2609) / 4.9382, coef4 * (72.9 - 39.2609) / 4.9382),
      Math.max(coef5 * (5.2 - 13.2827) / 1.7563, coef5 * (20.3 - 13.2827) / 1.7563),
      Math.max(coef6 * (1.2 - 29.1430) / 11.6875, coef6 * (84.1 - 29.1430) / 11.6875),
      Math.max(coef7 * (660 - 6126) / 2824, coef7 * (55000 - 6126) / 2824),
      Math.max(coef8 * (5300 - 237882.4) / 83295.69, coef8 * (734000 - 237882.4) / 83295.69)
    ]
    // Calculating
    const ageVal = (age1 * coef1[0]) + (age2 * coef1[1]) + (age3 * coef1[2])
    const sobVal = sob * coef2
    const tempVal = temperature * coef3
    const hctVal = hct * coef4
    const hgbVal = hgb * coef5
    const lympVal = lymphocyte * coef6
    const wbcVal = wbc * coef7
    const pltVal = plt * coef8

    const agePoint = (ageVal - ageMin)
    const sobPoint = (sobVal - sobMin)
    const tempPoint = (tempVal - tempMin)
    const hctPoint = (hctVal - hctMin)
    const hgbPoint = (hgbVal - hgbMin)
    const lympPoint = (lympVal - lympMin)
    const wbcPoint = (wbcVal - wbcMin)
    const pltPoint = (pltVal - pltMin)

    const totalPoint = agePoint + sobPoint + tempPoint + hctPoint + hgbPoint + lympPoint + wbcPoint + pltPoint
    const maxPoint = ageMax + sobMax + tempMax + hctMax + hgbMax + lympMax + wbcMax + pltMax - (ageMin + sobMin + tempMin + hctMin + hgbMin + lympMin + wbcMin + pltMin)
    const logit = coef0 + ageVal + sobVal + tempVal + hctVal + hgbVal + lympVal + wbcVal + pltVal
    const prob = Math.exp(logit) / (Math.exp(logit) + 1)
    console.log(hct,hgb,lymphocyte,wbc,plt)
    console.log(logit,prob)
    //  Bar Animation
    let i = d3.piecewise(d3.interpolateRgb.gamma(1), (["green", "#F5E772", "#E32D50"]))
    // TotalBar
    const totalWidth = 6
    const totalBar = bounds.append("g").attr("transform", "translate(70,300)")
    const totalBarScale = d3.scaleLinear().domain([0, 100]).range([
      0, totalWidth * 100
    ])
    const totalBarAxisGenerator = d3.axisBottom().scale(totalBarScale)
    const totalBarText = totalBar.append("text").text("Total Points").attr("font-weight", "bold").attr("text-anchor", "start").attr("x", -110)
    const totalBarAxis = totalBar.append("g").call(totalBarAxisGenerator)
    const totalRect = totalBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", totalBarScale(100 * totalPoint / maxPoint)).attr("fill", i(totalPoint / maxPoint))
    const totalText = totalBar.append("text").transition().duration(1000).text(`${Math.round(100 * (totalPoint / maxPoint))}pt`).attr("x", totalBarScale(100 * (totalPoint / maxPoint) + 1)).attr("font-size", 15).attr("font-weight", "bold")

    // ageBar

    const ageBar = bounds.append("g").attr("transform", "translate(70,0)")

    const ageBarScale = d3.scaleLinear().domain([
      0, 100 * (ageMax - ageMin) / maxPoint
    ]).range([
      0, 100 * (ageMax - ageMin) / maxPoint * totalWidth
    ])
    const ageBarAxisGenerator = d3.axisBottom().scale(ageBarScale).ticks(5)
    const ageBarText = ageBar.append("text").text("Age").attr("x", -110).attr("font-weight", "bold").attr("text-anchor", "start")
    const ageBarAxis = ageBar.append("g").call(ageBarAxisGenerator)
    const ageRect = ageBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", ageBarScale(100 * (agePoint / maxPoint))).attr("fill", i(agePoint / (ageMax - ageMin)))
    const ageText = ageBar.append("text").transition().duration(1000).text(`${Math.round(100 * (agePoint / maxPoint))}pt`).attr("x", ageBarScale(100 * (agePoint / maxPoint) + 1)).attr("font-size", 14).attr("font-weight", "bold")

    // sob bar
    const sobBar = bounds.append("g").attr("transform", "translate(70,50)")

    const sobBarScale = d3.scaleLinear().domain([
      0, 100 * (sobMax-sobMin) / maxPoint
    ]).range([
      0,
      (sobMax-sobMin) / maxPoint * totalWidth * 100
    ])
    const sobBarAxisGenerator = d3.axisBottom().scale(sobBarScale).ticks(1)
    const sobBarText = sobBar.append("text").text("SOB").attr("text-anchor","start").attr("x",-110).attr("font-weight", "bold")
    const sobBarAxis = sobBar.append("g").call(sobBarAxisGenerator)
    const sobRect = sobBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", sobBarScale(100 * (sobPoint / maxPoint))).attr("fill", i(sobPoint / (sobMax-sobMin)))
    const sobText = sobBar.append("text").transition().duration(1000).text(`${Math.round(100 * (sobPoint / maxPoint))}pt`).attr("x", sobBarScale(100 * (sobPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // TempBar
    const tempBar = bounds.append("g").attr("transform", "translate(70,100)")

    const tempBarScale = d3.scaleLinear().domain([
      0, 100 * (((tempMax-tempMin) / maxPoint))
    ]).range([
      0,
      (((tempMax-tempMin) / maxPoint)) * totalWidth * 100
    ])
    const tempBarAxisGenerator = d3.axisBottom().scale(tempBarScale).ticks(1)
    const tempBarText = tempBar.append("text").text("Temperature").attr("text-anchor","start").attr("x",-110).attr("font-weight", "bold")
    const tempBarAxis = tempBar.append("g").call(tempBarAxisGenerator)
    const tempRect = tempBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", tempBarScale(100 * (tempPoint / maxPoint))).attr("fill", i(tempPoint / (tempMax-tempMin)))
    const tempText = tempBar.append("text").transition().duration(1000).text(`${Math.round(100 * (tempPoint / maxPoint))}pt`).attr("x", tempBarScale(100 * (tempPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // hct bar
    const hctBar = bounds.append("g").attr("transform", "translate(70,150)")

    const hctBarScale = d3.scaleLinear().domain([
      0, 100 * (((hctMax - hctMin) / maxPoint))
    ]).range([
      0,
      (((hctMax - hctMin) / maxPoint)) * totalWidth * 100
    ])
    const hctBarAxisGenerator = d3.axisBottom().scale(hctBarScale).ticks(5)
    const hctBarText = hctBar.append("text").text("HCT").attr("x", -110).attr("font-weight", "bold").attr("text-anchor","start")
    const hctBarAxis = hctBar.append("g").call(hctBarAxisGenerator)
    const hctRect = hctBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", hctBarScale(100 * (hctPoint / maxPoint))).attr("fill", i(hctPoint / (hctMax - hctMin)))
    const hctText = hctBar.append("text").transition().duration(1000).text(`${Math.round(100 * (hctPoint / maxPoint))}pt`).attr("x", hctBarScale(100 * (hctPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // lympobar
    const lympBar = bounds.append("g").attr("transform", "translate(70,200)")

    const lympBarScale = d3.scaleLinear().domain([
      0, 100 * (((lympMax-lympMin) / maxPoint))
    ]).range([
      0,
      (((lympMax-lympMin) / maxPoint)) * totalWidth * 100
    ])
    const lympBarAxisGenerator = d3.axisBottom().scale(lympBarScale).ticks(5)
    const lympBarText = lympBar.append("text").text("Lymphocyte").attr("text-anchor","start").attr("x",-110).attr("font-weight", "bold")
    const lympBarAxis = lympBar.append("g").call(lympBarAxisGenerator)
    const lympRect = lympBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", lympBarScale(100 * (lympPoint / maxPoint))).attr("fill", i(lympPoint / (lympMax-lympMin)))
    const lympText = lympBar.append("text").transition().duration(1000).text(`${Math.round(100 * (lympPoint / maxPoint))}pt`).attr("x", lympBarScale(100 * (lympPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // Plt Bar
    const pltBar = bounds.append("g").attr("transform", "translate(70,250)")

    const pltBarScale = d3.scaleLinear().domain([
      0, 100 * (((pltMax-pltMin) / maxPoint))
    ]).range([
      0,
      (((pltMax-pltMin) / maxPoint)) * totalWidth * 100
    ])
    const pltBarAxisGenerator = d3.axisBottom().scale(pltBarScale)
    const pltBarText = pltBar.append("text").text("PLT").attr("text-anchor","start").attr("x",-110).attr("font-weight", "bold")
    const pltBarAxis = pltBar.append("g").call(pltBarAxisGenerator)
    const pltRect = pltBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", pltBarScale(100 * (pltPoint / maxPoint))).attr("fill", i(pltPoint / (pltMax-pltMin)))
    const pltText = pltBar.append("text").transition().duration(1000).text(`${Math.round(100 * (pltPoint / maxPoint))}pt`).attr("x", pltBarScale(100 * (pltPoint / maxPoint)+1)).attr("font-size",14).attr("font-weight","bold")
    // Prob Bar
    const probBar = bounds.append("g").attr("transform", "translate(70,350)")

    const probBarScale = d3.scaleLinear().domain([0, 1]).range([
      0, totalWidth * 100
    ])
    const probBarAxisGenerator = d3.axisBottom().scale(probBarScale)
    const probBarText = probBar.append("text").text("Probability").attr("text-anchor","start").attr("x",-110).attr("font-weight", "bold")
    const probBarAxis = probBar.append("g").call(probBarAxisGenerator)
    const probRect = probBar.append("rect").attr("y", -10).attr("width", 0).attr("height", 10).attr("fill", "green").transition().duration(1000).attr("width", probBarScale(prob)).attr("fill", i(prob))
    const probText = probBar.append("text").transition().duration(1000).text(`${Math.round(100 * prob)}%`).attr("x", probBarScale(prob)+5).attr("font-size",15).attr("font-weight","bold")

  }, [props.data])

  return (<Box border="3px solid gray">
    <svg ref={ref}/>
  </Box>)
}

export default Output2
